import React, { useRef, useEffect } from 'react';
import { useLocation, Switch } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
// import ReactGA from 'react-ga';
//
// import CookieBanner from './utils/cookies-banner';
// import { CookieConsentProvider } from '@use-cookie-consent/react';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';
// import LayoutNew from './layouts/LayoutNew';
import FeaturesSplit from './components/sections/FeaturesSplit';

// Views
import Home from './views/Home';
import FeaturesTiles from './components/sections/FeaturesTiles';
import Cta2 from './components/sections/Cta2';
// import CookiesPolicy from './components/sections/CookiesPolicy';
// import PrivatePolicy from './components/sections/PrivacyPolicy';
// import Testimonial from './components/sections/Testimonial';

// Initialize Google Analytics
// ReactGA.initialize(process.env.REACT_APP_GA_CODE);

const trackPage = (page) => {
  console.log(page);
  //   ReactGA.set({ page });
  //   console.log(page);
  //   ReactGA.pageview(page);
};

const App = () => {
  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add('is-loaded');
    childRef.current.init();
    // console.log('APp.js', page);
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <>
      {/* <CookieBanner /> */}
      {/* <CookieConsentProvider> */}
      <ScrollReveal
        ref={childRef}
        children={() => (
          <Switch>
            <AppRoute exact path="/" component={Home} layout={LayoutDefault} />
            <AppRoute
              path="/kontaktai"
              component={Cta2}
              layout={LayoutDefault}
            />
            <AppRoute
              path="/apiemus"
              component={FeaturesTiles}
              layout={LayoutDefault}
            />
            <AppRoute
              path="/pavyzdziai"
              component={FeaturesSplit}
              layout={LayoutDefault}
            />
            {/* <AppRoute
              path="/CookiesPolicy"
              component={CookiesPolicy}
              layout={LayoutNew}
            />
            <AppRoute
              path="/PrivatePolicy"
              component={PrivatePolicy}
              layout={LayoutNew}
            /> */}
          </Switch>
        )}
      />
      {/* </CookieConsentProvider> */}
    </>
  );
};

export default App;
